import React from 'react';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {createStackNavigator, StackHeaderProps} from '@react-navigation/stack';
import {ThemeProvider} from '@rneui/themed';

import BrandHeader from '../components/BrandHeader';
import {AppRoute} from '../models/AppRoute';
import {HeaderConfig, RootPromotionsFlowParamList} from '../models/navigationTypes';
import CompetitionOptOutScreen from '../screens/promotions/CompetitionOptOutScreen';
import rewardsTheme from '../theme/rewardsTheme';

import useCommonScreenOptions from './hooks/useCommonScreenOptions';

export const header =
  (config: HeaderConfig) =>
  ({navigation, route}: StackHeaderProps) => (
    <BrandHeader navigation={navigation} route={route} config={config} />
  );

const Stack = createStackNavigator<RootPromotionsFlowParamList>();

const RootPromotionsFlowStackNavigator = () => {
  const commonScreenOptions = useCommonScreenOptions(true);

  return (
    <ThemeProvider theme={rewardsTheme}>
      <GestureHandlerRootView style={{flex: 1}} testID="gesture-handler-root-view">
        <Stack.Navigator detachInactiveScreens={true} screenOptions={commonScreenOptions}>
          <Stack.Screen
            name={AppRoute.PROMOTIONS_OPT_OUT}
            component={CompetitionOptOutScreen}
            options={{
              header: header({
                back: true,
                shop: false,
                filter: false,
                burger: false,
                search: false,
                blinkerMode: true,
                source: 'Competition Opt-Out',
              }),
            }}
          />
        </Stack.Navigator>
      </GestureHandlerRootView>
    </ThemeProvider>
  );
};

export default RootPromotionsFlowStackNavigator;
